 import { pageName } from 'src/assets/common/enums/page-name.g';
import { tabName } from 'src/assets/common/enums/tab-name.g';

// Pages and tabs are both authorizable units (a Claim references either via Claim.PageId).
// The exporter generates them as separate consts (driven by the Kind column on Pages);
// claim_check works against either, so the claim "page" is their union.
export const claimPage = { ...pageName, ...tabName } as const;
export type ClaimPage = (typeof claimPage)[keyof typeof claimPage];
